import { route as contacts } from '../contacts';
import { route as writing } from '../writing';
import { route as info } from '../info';
import { route as newContacts } from '../new-contacts';
import { route as newsletters } from '../newsletters';
import { route as outbox } from '../outbox';
import { route as root } from '../root';
import { route as schools } from '../schools';
import { route as newsletter } from '../newsletter';
import { route as auth } from '../auth';

export default [
  root,
  schools,
  info,
  newsletters,
  writing,
  outbox,
  newsletter,
  contacts,
  newContacts,
  auth,
];
